import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksRecomendedMachines(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES].getRegulationsStagesPlanWorksRecomendedMachines,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}

export default {
	getRegulationsStagesPlanWorksRecomendedMachines,
}
